import { useCommunityContext } from 'providers';

import { useListCommunityContentRestrictionsQuery } from 'shared/graphql';
import { useHasSession } from 'shared/hooks';

/**
 * Custom hook to fetch content restrictions for the currently selected community.
 *
 * This hook retrieves the list of content restrictions associated with the selected community, using the current session and community context.
 *
 * @see https://github.com/jebelapp/jebel/issues/1842
 */
export function useCommunityContentRestrictions() {
  const hasSession = useHasSession();

  const { selectedCommunity: community } = useCommunityContext();

  const { data, loading, error } = useListCommunityContentRestrictionsQuery({
    skip: !hasSession || !community?.id,
    variables: { community: community?.id as string },
  });

  const restrictions = data?.restrictions ?? [];

  return {
    data: restrictions,
    loading,
    error,
  };
}
